import { useSelector } from 'react-redux';
import ScenarioButtonText from './ScenarioButtonText';

function ActionButtonText() {
  const actionButtonText = useSelector(
    (state) => state.content.actionButtonText
  );

  // Return action button text if specified
  if (actionButtonText) return <>{actionButtonText}</>;

  // Otherwise use depending on scenario
  return <ScenarioButtonText />;
}

export default ActionButtonText;
